module.exports = __webpack_public_path__ + "static/media/video-btn.14983884.svg";